import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './styles/home-modular.css';
import logo from './image/logo.png';



import TechnicalImg1 from './image/TechnicalPrograms/1.jpeg';
import TechnicalImg2 from './image/TechnicalPrograms/2.jpeg';
import TechnicalImg3 from './image/TechnicalPrograms/3.jpeg';

import PracticalImg1 from './image/PracticalApproach/1.jpeg';
import PracticalImg2 from './image/PracticalApproach/2.jpeg';
import PracticalImg3 from './image/PracticalApproach/3.jpeg';

import ShipImg1 from './image/Ship/1.png';
import ShipImg2 from './image/Ship/2.png';
import ShipImg3 from './image/Ship/3.png';

import TeacherImg1 from './image/Teachers/1.jpeg';
import TeacherImg2 from './image/Teachers/2.jpeg';
import TeacherImg3 from './image/Teachers/3.jpeg';

import CertificationsImg1 from './image/Certifications/1.png';
import CertificationsImg2 from './image/Certifications/2.png';
import CertificationsImg3 from './image/Certifications/3.png';

// Crear un objeto que contenga múltiples imágenes con un solo nombre
const programImages = {
  TecnicalProgram: [TechnicalImg1, TechnicalImg2, TechnicalImg3],
  PracticalApproach: [PracticalImg1, PracticalImg2, PracticalImg3],
  ship: [ShipImg1, ShipImg2, ShipImg3],
  TeacherTeam: [TeacherImg1, TeacherImg2, TeacherImg3],
  Certifications: [CertificationsImg1, CertificationsImg2, CertificationsImg3]
};



const Home = () => {
  const [currentFeature, setCurrentFeature] = useState(0);
  const [currentImageIndexes, setCurrentImageIndexes] = useState([0, 0, 0, 0, 0]); // Un índice para cada tarjeta

  const studentGallery = [
    {
      images: programImages.TecnicalProgram, // Múltiples imágenes para academic
      title: "Programas Técnicos con Alta Demanda Laboral",
      description: "Forma parte de carreras que responden a las necesidades reales del mercado como Administración, Contabilidad, Tecnología, Servicio Social, Investigación Judicial, Enfermería, Seguridad Ocupacional y Primera Infancia."
    },
    {
      images: programImages.PracticalApproach, // Múltiples imágenes para finance
      title: "Enfoque Práctico y Actualizado",
      description: "Aprende haciendo. Nuestros programas combinan teoría y práctica para que adquieras experiencia desde el primer día."
    },
    {
      images: programImages.ship, // Múltiples imágenes para report
      title: "Formación para el Emprendimiento",
      description: "Cada carrera impulsa tu capacidad para crear y liderar proyectos propios con visión empresarial."
    },
    {
      images: programImages.TeacherTeam, // Múltiples imágenes para student
      title: "Docentes con Experiencia Real",
      description: "Nuestros instructores son profesionales activos en sus áreas, listos para guiarte con conocimiento aplicado."
    },
    {
      images: programImages.Certifications, // Múltiples imágenes para student
      title: "Certificación Reconocida",
      description: "Obtén un título técnico laboral avalado que te abrirá puertas en el ámbito productivo y empresarial."
    },
  ];

  // Efecto para cambiar la tarjeta principal cada 3 segundos
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentFeature((prev) => (prev + 1) % studentGallery.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [studentGallery.length]);

  // Efecto para cambiar las imágenes de cada tarjeta en secuencia
  useEffect(() => {
    let currentCardIndex = 0;
    
    const interval = setInterval(() => {
      setCurrentImageIndexes(prev => {
        const newIndexes = [...prev];
        // Cambia solo la tarjeta actual
        newIndexes[currentCardIndex] = (newIndexes[currentCardIndex] + 1) % 3;
        
        // Pasa a la siguiente tarjeta
        currentCardIndex = (currentCardIndex + 1) % studentGallery.length;
        
        return newIndexes;
      });
    }, 2000); // Cambia cada 2 segundos
    
    return () => clearInterval(interval);
  }, [studentGallery.length]);

  return (
    <div className="home-container">
      {/* Partículas de fondo */}
      <div className="floating-particles">
        {[...Array(20)].map((_, i) => (
          <div key={i} className="particle" style={{
            '--delay': `${Math.random() * 5}s`,
            '--duration': `${4 + Math.random() * 5}s`,
            '--size': `${2 + Math.random() * 4}px`,
            '--x': `${Math.random() * 100}%`,
            '--y': `${Math.random() * 100}%`
          } as React.CSSProperties} />
        ))}
      </div>

      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <div className="hero-left">
            <div className="hero-badge">
              <span className="hero-badge-dot"></span>
              Institución Técnica en La Guajira
            </div>

            <div className="hero-title-row">
              <div className="logo-container">
                <img src={logo} alt="CECAP" className="hero-logo" />
                <div className="logo-glow"></div>
              </div>
              <h1 className="hero-title">
                CECAP
                <br />
                <span className="hero-subtitle">MAICAO</span>
              </h1>
            </div>

            <p className="hero-description">
              CECAP forma técnicos competentes en La Guajira, combinando teoría y práctica para conectar el aprendizaje con oportunidades reales de empleo y emprendimiento.
            </p>

            <div className="hero-buttons">
              <Link to="/pricing" className="cta-button primary">
                <span>Ver Programas</span>
                <div className="button-glow"></div>
              </Link>
              <Link to="/contact" className="cta-button secondary">
                <span>Contáctanos</span>
              </Link>
            </div>

            <div className="hero-stats">
              <div className="hero-stat">
                <span className="hero-stat-number">8</span>
                <span className="hero-stat-label">Programas técnicos</span>
              </div>
              <div className="hero-stat">
                <span className="hero-stat-number">100%</span>
                <span className="hero-stat-label">Certificación reconocida</span>
              </div>
              <div className="hero-stat">
                <span className="hero-stat-number">Flex</span>
                <span className="hero-stat-label">Horarios adaptados</span>
              </div>
            </div>
          </div>

          <div className="hero-right">
            <div className="feature-showcase">
              <div className="feature-card">
                <div className="feature-image">
                  <img
                    key={`${currentFeature}-${currentImageIndexes[currentFeature]}`}
                    src={studentGallery[currentFeature].images[currentImageIndexes[currentFeature]]}
                    alt={studentGallery[currentFeature].title}
                  />
                </div>
                <div className="feature-card-body">
                  <div className="feature-card-meta">
                    <span className="feature-card-dot"></span>
                    <span className="feature-card-label">Programa destacado</span>
                  </div>
                  <h3>{studentGallery[currentFeature].title}</h3>
                  <p>{studentGallery[currentFeature].description}</p>
                  <div className="feature-dots">
                    {studentGallery.map((_, i) => (
                      <div key={i} className={`feature-dot${i === currentFeature ? ' active' : ''}`} />
                    ))}
                  </div>
                </div>
                <div className="feature-glow"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats-section">
        <div className="stats-container">
          <div className="stat-card">
            <div className="stat-number">Integral</div>
            <div className="stat-label">Formación Completa</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">Humano</div>
            <div className="stat-label">Con Valores</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">Comprometido</div>
            <div className="stat-label">Con la Comunidad</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">Competente</div>
            <div className="stat-label">En el Mundo Laboral</div>
          </div>
        </div>
      </section>

      {/* Student Gallery */}
      <section className="student-gallery">
        <h2 className="section-title">¿Por qué elegir CECAP?</h2>
        <p className="section-subtitle">Programas diseñados para el mundo laboral real, con docentes activos y certificación reconocida.</p>
        <div className="gallery-container">
          {studentGallery.map((student, index) => (
            <div key={index} className="gallery-item" style={{
              animationDelay: `${index * 0.2}s`
            }}>
              <div className="gallery-image">
                <div className="carousel-container">
                  <img 
                    key={`${index}-${currentImageIndexes[index]}`}
                    src={student.images[currentImageIndexes[index]]} 
                    alt={`${student.title} ${currentImageIndexes[index] + 1}`} 
                    className="carousel-image"
                  />
                </div>
                <div className="image-overlay">
                  <h3>{student.title}</h3>
                  <p>{student.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Home; 